import Cookies from "js-cookie";

export function useAuth() {
  const token = Cookies.get("token");
  
  return { isAuthenticated: !!token };
}